/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/layout/get-field-zone-layout";
import { UrlFieldDisplay } from "./display";
import { UrlFieldEdit } from "./edit";

const UrlField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <UrlFieldDisplay />,
        editComponent: <UrlFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
UrlField.displayName = "UrlField";
export { UrlField };
